<!-- <app-header-one></app-header-one> -->
<app-header-latest></app-header-latest>

<section class="login-page section-b-space">
  <div class="container">
    <div class="custom-form">
      <div class="row">
        <div class="col-lg-10 offset-lg-1">
          <div class="theme-card">
            <h2>Vendor / Business Partner Registration</h2>
            <!-- {{referralChecked}} -->
            <div class="row">

              <div class="col-md-4">
                <form [formGroup]="validateForm" (ngSubmit)="onSubmit()">
                  <div class="form-group form-group-change position-relative">
                    <mat-form-field appearance="outline" class="custom-width">
                      <mat-label>NEOJOBZ Referral ID</mat-label>
                      <input matInput type="text" formControlName="referral_code" placeholder="eg: WRXXXXXXXXXXXXX" />
                    </mat-form-field>
                    <mat-error *ngIf="referralChecked && !referralValid">
                      Invalid referral code, Please enter valid referral code.
                    </mat-error>
                    <button type="button" *ngIf="validateForm.get('referral_code')?.value" (click)="clearReferral()"
                      class="input-clear-btn">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path
                          d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                      </svg>
                    </button>
                  </div>
                </form>

                
                <!-- <div *ngIf="referralChecked && !referralValid" class="text-danger mt-2">
                  Invalid referral code, Please enter valid referral code.
                </div> -->
              </div>
              <div class="col-md-2">
                <button (click)="getReferralName()" class="btn btn-solid" [disabled]="
      validateForm.get('referral_code')?.invalid ||
      validateForm.get('referral_code')?.pristine ||
      !validateForm.get('referral_code')?.value?.trim() ||
      referralValid
    ">
                  Validate
                </button>
              </div>
              <div class="col-md-6">
                <div *ngIf="referralChecked && referralValid" class="border p-3 rounded ms-3 mt-2">
                  <span><b>Referee:</b></span>
                  <span class="mx-2" style="color:#5f4bde">{{ refaralData?.first_name }}</span>
                  <span style="color:#5f4bde">{{ refaralData?.last_name }}</span>
                </div>
              </div>
            </div>

            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-md-4">
                  <div class="d-flex justify-content-between custo-cheaps">

                    <!-- <mat-chip-set aria-label="Dog selection" (click)="selectType($event)">
                      @for (dog of bestBoys; track dog) {
                      <mat-chip [value]="dog.value">
                        {{dog.name}}
                      </mat-chip>
                    }
                    </mat-chip-set> -->
                    <!-- <mat-chip-set aria-label="Fish selection">
                      <mat-chip [ngClass]="{'seletedRoleActive text-white': seletedRole === chart_btn.value}"
                        *ngFor="let chart_btn of bestBoys" [value]="chart_btn.value"
                        (click)="toggleSelection(chart_btn.value)">{{chart_btn.name}}</mat-chip>
                    </mat-chip-set> -->
 

                    <mat-chip-listbox class="horizontal-chip-list" aria-label="Cutest dog breeds">
                      <mat-chip-option 
                        *ngFor="let chart_btn of bestBoys"
                        [ngClass]="{'seletedRoleActive text-white': seletedRole === chart_btn.value}"
                        (click)="toggleSelection(chart_btn.value)">
                        {{ chart_btn.name }}
                      </mat-chip-option>
                    </mat-chip-listbox>
                  </div>
                    <!-- Error message -->
                    <div class="text-danger mt-1" *ngIf="showRoleError">
                      Please select a role.
                    </div>

                  
                </div>
              </div>


              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-group-change">
                    <mat-form-field appearance="outline" class="custom-width">
                      <mat-label>First name</mat-label>
                      <input matInput type="text" formControlName="first_name" placeholder="eg: John Doe " />
                      <mat-error *ngIf="form.get('first_name').hasError('required')">
                        Field is required.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group form-group-change">
                    <mat-form-field appearance="outline" class="custom-width">
                      <mat-label>Last name</mat-label>
                      <input matInput type="text" formControlName="last_name" placeholder="eg: Kumar" />
                      <mat-error *ngIf="form.get('last_name').hasError('required')">
                        Field is required.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-group-change">
                    <mat-form-field appearance="outline" class="custom-width">
                      <mat-label>Email</mat-label>
                      <input matInput type="text" formControlName="email" placeholder="eg: johndoe@gmail.com" />
                      <mat-error *ngIf="form.get('email')?.hasError('email') && !form.get('email')?.pristine">
                        Invalid Email ID
                      </mat-error>
                      <mat-error
                        *ngIf="form.get('email')?.hasError('required') && (form.get('email')?.dirty || form.get('email')?.touched)">
                        Field is required.
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group form-group-change">
                    <mat-form-field appearance="outline" class="custom-width">
                      <mat-label>Mobile</mat-label>
                      <input matInput type="number" formControlName="mobile" placeholder="eg: +91-70 75 85 5784 "
                        autocomplete="off" />
                      <mat-hint
                        *ngIf="form.get('mobile')?.hasError('required') && (form.get('mobile')?.dirty || form.get('mobile')?.dirty)"
                        class="error-message">
                        Field is required.
                      </mat-hint>
                      <mat-hint
                        *ngIf="form.get('mobile')?.hasError('pattern') && (form.get('mobile')?.dirty || form.get('mobile')?.dirty)"
                        class="error-message">
                        Mobile number must be exactly 10 digits.
                      </mat-hint>
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div class="row" style="margin-top: 1%;">
                <div class="col-md-6">
                  <div class="form-group form-group-change">
                    <mat-form-field appearance="outline">
                      <mat-label>Password</mat-label>
                      <input matInput placeholder="Password" [type]="hide ? 'password' : 'text'" formControlName="p"
                        placeholder="eg: Password@123" required autocomplete="off">
                      <mat-icon style="color: #5f4bde;" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' :
                        'visibility'}}</mat-icon>


                      <!--  <input matInput placeholder="Password" [type]="showpassword ? 'text' : 'password'"
                        formControlName="password" required>
                      <mat-icon matSuffix (click)="toggleShowPassword()">{{showpassword ? 'visibility_off_outline' :
                        'visibility_outline'}}</mat-icon> -->

                      <!-- <mat-hint style="color:var(--mat-form-field-error-text-color);
                    " *ngIf="form.get('password')?.value && !hasSpecialCharacter(form.get('password')?.value) && form.get('password')?.dirty" > ppppp
                      </mat-hint> -->
                    </mat-form-field>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group form-group-change">
                    <mat-form-field appearance="outline">
                      <mat-label>Confirm Password</mat-label>
                      <input matInput placeholder="Password" [type]="confirmPasswordhide ? 'password' : 'text'"
                        formControlName="confirm_password" placeholder="eg: Password@123" required>
                      <mat-icon matSuffix (click)="confirmPasswordhide = !confirmPasswordhide">{{confirmPasswordhide ?
                        'visibility_off' : 'visibility'}}</mat-icon>
                      <!-- <input matInput placeholder="Confirm Password"
                        [type]="confirmPasswordVisible ? 'text' : 'password'" formControlName="confirm_password"
                        required>
                      <mat-icon matSuffix (click)="toggleConfirmPasswordVisibility()">
                        {{confirmPasswordVisible ? 'visibility_off' : 'visibility'}}
                      </mat-icon> -->
                      <!-- <mat-error
                      *ngIf="form.hasError('mismatch') && (form.get('password')!.dirty || form.get('confirm_password')!.dirty)">
                        Passwords do not match.
                      </mat-error> -->
                      <mat-hint style="color:var(--mat-form-field-error-text-color);
                    " *ngIf="form.hasError('mismatch') && (form.get('confirm_password')?.touched || form.get('password')?.touched)">
                        Password do not match.
                      </mat-hint>
                    </mat-form-field>
                    <!-- <div style="position: absolute;" *ngIf="form.hasError('mismatch') && (form.get('confirm_password')?.dirty || form.get('password')?.dirty)" class="error-message">
                    </div> -->
                    <!-- <div )"
                    class="validation-errors">
                    <div class="error-message">
                      <p>Passwords do not match.</p>
                    </div>
                  </div> -->
                  </div>
                </div>
              </div>

              <!-- <p-password formControlName="confirm_password" [toggleMask]="true">
                <ng-template pTemplate="header">
                    <h6>Pick a password</h6>
                </ng-template>
                <ng-template pTemplate="footer">
                    <p-divider />
                    <p class="mt-2">Suggestions</p>
                    <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                        <li>At least one lowercase</li>
                        <li>At least one uppercase</li>
                        <li>At least one numeric</li>
                        <li>Minimum 8 characters</li>
                    </ul>
                </ng-template>
            </p-password> -->

              <!-- <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group form-group-change">
                                        <mat-form-field appearance="outline" class="custom-width">
                                          <mat-label>Plan Name</mat-label>
                                          <mat-select formControlName="plan_id">
                                            <mat-option *ngFor="let plan of plans" [value]="plan.id">
                                              {{ plan.plan_title }}
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                       
                                      </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group form-group-change">
                                      <mat-form-field appearance="outline">
                                        <mat-label>Plan Date</mat-label>
                                        <input
                                          matInput
                                          [matDatepicker]="picker"
                                          formControlName="plan_start_date"
                                          (click)="picker.open()"
                                        />
                                        <mat-datepicker-toggle
                                          matIconSuffix
                                          [for]="picker"
                                        ></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                        <mat-error
                                          *ngIf="
                                            form.get('plan_start_date').hasError('required') &&
                                            form.get('plan_start_date').touched
                                          "
                                          >Plan Start Date is required.</mat-error
                                        >
                                      </mat-form-field>
                                    </div>
                                    
                                  </div>
                                                                
                            </div> -->

              <!-- <div class="row">
                <div class="col-md-6">
                  <div class="form-group form-group-change">
                    <mat-form-field appearance="outline">
                      <mat-label>Role</mat-label>
                      <mat-select formControlName="role" placeholder="eg: Agent">
                        <mat-option value="VENDOR">Vendor</mat-option>
                        <mat-option value="AGENT">Agent</mat-option>
                      </mat-select>
                      <mat-error *ngIf="form.get('role').hasError('required')">Job type is required</mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div> -->

              <div class="row">


                <p>Already a  member?
                <a class="primary-color" (click)="goTo('/login')"
                    class="forgot-password-link " style="color: #5f4dbe; cursor: pointer;">Sign In</a></p>

              </div>

              <div class="row">
                <div style="display: flex;flex-direction: column; color: #5f4bde;position: absolute;">
                  <mat-hint *ngIf="form.get('p')?.hasError('required') && form.get('p')?.dirty">
                    Field is required.
                  </mat-hint>
                  <mat-hint *ngIf="form.get('p')?.hasError('minlength') && form.get('p')?.dirty">
                    Password must be at least 8 characters long.
                  </mat-hint>
                  <mat-hint
                    *ngIf="form.get('p')?.value && !hasUppercaseLetter(form.get('p')?.value) && form.get('p')?.dirty">
                    Password must contain at least one uppercase letter (A-Z).
                  </mat-hint>

                  <mat-hint *ngIf="form.get('p').hasError('lowercase') && form.get('p').dirty">
                    Password must contain at least one lowercase letter.
                  </mat-hint>

                  <mat-hint *ngIf="form.get('p')?.value && !hasNumber(form.get('p')?.value) && form.get('p')?.dirty">
                    Password must contain at least one number (0-9).
                  </mat-hint>
                  <mat-hint
                    *ngIf="form.get('p')?.value && !hasSpecialCharacter(form.get('p')?.value) && form.get('p')?.dirty">
                    Password must contain at least one special character.
                  </mat-hint>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-10"></div>
                <div class="col-lg-2">
                  <button type="submit" class="btn btn-solid"
                  [disabled]="!form.valid || (validateForm.get('referral_code')?.value?.trim() && !referralValid)">Submit</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- <app-footer-one></app-footer-one> -->
<div class="gray-bg py-0">
  <app-our-apps></app-our-apps>
</div>
<app-footer-more-info></app-footer-more-info>